import React, { useEffect, useState, createRef, useContext, useRef } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Button, TablePagination } from '@material-ui/core';
import { tablePageRows, defaultRows } from '../../../constants/ReusableTablePagination';
import { httpPaginationPost } from '../../../util/Rest';
import { ThemeContext } from '../../../themes/ThemeProvider';
import GuiTable from '../../../components/FormComponents/GuiTable';
import { ArrowBack } from '@material-ui/icons';
import PageLoader from '../../../components/PageLoader';
import { setShowDashboardWorkQueue } from '../../../redux/reducers/role';
import { SPLIT_SCREEN } from '../../../constants/WorkQueueConstants';
import { changeWorkQueueSession } from '../../../redux/reducers/WorkQueueList';
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles(() => ({
  tableAlign: {
    marginTop: '64px',
    marginBottom: '15px',
  },
  disabledWorkQueue: {
    color: '#676767',
    textDecoration: 'underline',
  },
  heading: {
    fontSize: '0.75rem',
  },
  workQueueTitle: {
    display: 'flex',
    '& p': {
      marginBottom: '0px',
    },
    '& p:nth-child(2)': {
      marginLeft: '15px',
    },
  },
}));
const WorkQueueListTable = () => {
  const styles = useStyles();
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [isColumnsAdd, setIsColumnsAdd] = useState(true);
  const history = useHistory();
  const tableRef = createRef();
  const payloadRef = useRef();
  const dispatch = useDispatch();
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [status, setStatus] = useState(false);
  const { isLoading } = useSelector(({ workQueueList }) => workQueueList);

  const workQueueRowData = history?.location?.state?.workQueueRowData;

  const handleRowClick = (event, rowData) => {
    const { workQueueId, orderBy, orderDirection } = payloadRef.current;
    const { updateSession } = changeWorkQueueSession();
    updateSession({
      [SPLIT_SCREEN.DONT_SHOW_SPLIT_SCREEN]: {
        orderBy: orderBy || '',
        orderDirection: orderDirection || '',
        workQueueId: workQueueId,
      },
      payload: payloadRef.current,
      workQueueRowData: workQueueRowData,
    });
    dispatch(setShowDashboardWorkQueue(workQueueRowData?.showDashboard));
    history.push({
      pathname: `/account-summary`,
      state: {
        fromWorkQueue: '/work-queue-list',
        accNo: rowData.account_number,
      },
    });
  };

  const columns = [
    {
      title: 'Account Number',
      field: 'account_number',
    },
  ];

  useEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);

  return (
    <>
      <div>
        <div
          className={`custom-table work-queue-list new-standard-textfields ${styles.tableAlign}`}
        >
          <div className={` ${classes.cardStyleWhite}`}>
            <div className="table-header  mb-2">
              <Button
                variant="outlined"
                type="button"
                className={`search-btn mx-1`}
                onClick={() => {
                  history.push({
                    pathname: '/work-queue',
                  });
                }}
              >
                <ArrowBack className="mr-2" />
                Back to Work Queue List
              </Button>
            </div>
            <div className="work-queue-table global-field-table">
              <GuiTable
                title={
                  <div className={styles.workQueueTitle}>
                    <p>
                      <b>Work Queue Name:</b>
                      {workQueueRowData?.workqueueName || ''}
                    </p>
                    <p>
                      <b>Work Queue Description:</b>
                      {workQueueRowData?.workqueueDescription || ''}
                    </p>
                  </div>
                }
                onRowClick={handleRowClick}
                columns={dynamicColumns || []}
                tableRef={tableRef}
                data={(query) =>
                  new Promise((resolve) => {
                    const url = `workqueue/execution/get/all/workqueue/data`;
                    const passValues = {
                      workQueueId: workQueueRowData?.workqueueId || '',
                      orderBy: query?.orderBy?.sortFieldObj || '',
                      orderDirection: query?.orderDirection || '',
                      limit: query.pageSize ? query.pageSize : null,
                      page:
                        arrayLast && query?.page >= 1
                          ? query.page
                          : arrayLast
                            ? (query.page <= 1 && query.page + 1) || query.page - 1
                            : query.page + 1,
                    };
                    payloadRef.current = passValues;
                    httpPaginationPost(url, passValues)
                      .then((response) => {
                        if (response?.status === 200) {
                          const data = response?.data?.response?.resultObject || [];
                          const fieldHeaders = response?.data?.response.fieldHeaders || [];
                          setArrayLast(data.length === 1);

                          const sortFields = response.data?.response?.sortFields || [];
                          const sortFieldObj = {};
                          sortFields.forEach((item) => {
                            sortFieldObj[item.sortingField] = item.orderBy;
                          });

                          if (fieldHeaders?.length > 0 && isColumnsAdd) {
                            fieldHeaders.forEach(({ fieldHeader, fieldName }) => {
                              if (fieldName !== 'IS_LOCKED' && fieldName !== 'ACCOUNT_NUMBER') {
                                columns.push({
                                  field: fieldName,
                                  title: fieldHeader,
                                  sortFieldObj: sortFieldObj[fieldHeader] || '',
                                });
                              } else if (fieldName === 'ACCOUNT_NUMBER') {
                                columns[0]['sortFieldObj'] = sortFieldObj[fieldHeader] || '';
                              }
                            });
                            setIsColumnsAdd(false);
                            setDynamicColumns(columns);
                          }
                          resolve({
                            data: data.length > 0 ? data : [],
                            page: response.data.response.page - 1,
                            totalCount: response.data.response.count,
                          });
                        } else {
                          resolve({
                            data: [],
                            page: 0,
                            totalCount: 5,
                          });
                        }
                      })
                      .catch((response) => {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                      });
                  })
                }
                options={{
                  search: false,
                  sorting: true,
                  pageSizeOptions: tablePageRows,
                  pageSize: rows,
                  emptyRowsWhenPaging: false,
                  headerStyle: {
                    fontWeight: 'bold',
                    zIndex: 0,
                  },
                }}
                components={{
                  Pagination: (props) => (
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: { 'aria-label': 'Rows per screen' },
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  ),
                }}
                actions={[
                  {
                    icon: () => (
                      <>
                        <div>
                          <Button
                            variant="outlined"
                            size="large"
                            className={`mx-1  search-btn`}
                            onClick={() => {
                              setStatus(true);
                            }}
                            startIcon={<RefreshIcon />}
                          >
                            Refresh
                          </Button>
                        </div>
                      </>
                    ),
                    isFreeAction: true,
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      {isLoading && <PageLoader />}
    </>
  );
};

export default WorkQueueListTable;
